import { Avatar, Button, Grid, Grid2, InputAdornment, MenuItem, Select, TextField, Typography , Box , LinearProgress} from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { GoogleMap, LoadScript, Marker, Polyline, useJsApiLoader, DirectionsRenderer } from '@react-google-maps/api';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import mapPin from '../../assets/icons/LocationPin.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import vehicleTypeCar from '../../assets/images/vehicleTypeCar.svg';
import vehicletypeAuto from '../../assets/images/vehicletypeAuto.svg';
import vehicleTypeBike from '../../assets/images/vehicleTypeBike.svg';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import AutoMarker from '../../assets/images//AutoMarker.svg';
import BikeMarker from '../../assets/images/bikeMarker.svg';
import CarMarker from '../../assets/images/carMarker.svg';
import useChunkedRideData from '../useChunkedRideData.js';
import RideRequestComponent from '../dispatcherCommon.jsx';
import axios from "axios";
import TokenError from "../tokenError";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import altAvatar from '../../assets/images/altAvatar.svg';
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/animations/Ride Finding Animation.json";
import CarDriver from '../../assets/images/Cab Driver.svg';
import successIcon from '../../assets/images/Sucess icon.svg';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');

const styles = {
    errorBox: {
      backgroundColor: '#EFFBF7',
      color: '#0DBA78',
      border: '1px solid #0DBA78',
      paddingLeft: '10%',
      paddingRight: '10%',
      borderRadius: '5px',
      marginTop: '6px'
    }
};

const Dispatcher = () => {
    const serverUrl = config.serverUrl;
    const autosUrl = config.autosUrl;
    const user_image="bgrss";
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const handleFilterChange = (filterType, value) => {    //handle the city filter
        if (filterType === 'city') setCityFilter(value);
    };

    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupLatLng, setPickupLatLng] = useState(null);

    const [dropLocation, setDropLocation] = useState('');
    const [dropLatLng, setDropLatLng] = useState(null);

    const [driversData, setDriversData] = useState([]);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isNearbyDrivers, setIsNearbyDrivers] = useState(false);
    const [phone, setPhone] = useState();
    const [userByPhone, setUserByPhone] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [fullScreenLoader, setFullScreenLoader] = useState(false);
    const [responseFlag, setResponseFlag] = useState(null); 

    const [autoRideAssigned, setAutoRideAssigned] = useState(false);
    const [noDriverFound, setNoDriverFound] = useState(false);

    // Create a ref to the input field
    const inputRef = useRef(null);   //pickup
    const inputDropRef = useRef(null);    //drop

    const loaderOptions = {
        id: 'google-map-script',
        googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
        libraries: LIBRARIES,
    }
    
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    useEffect(() => {   //autocomplete api of google
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['geocode'], // You can modify types depending on your use case (e.g., ['address', 'establishment'])
                componentRestrictions: { country: 'IN' }, // Optional: Restrict results to a specific country
                });
        
                // Add an event listener for when the place is selected
                autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    setPickupLatLng({
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    });
                    setPickupLocation(place.formatted_address || '');
                }
                });

                const autocompleteDrop = new window.google.maps.places.Autocomplete(inputDropRef.current, {
                    types: ['geocode'],
                    componentRestrictions: { country: 'IN' },
                });
                autocompleteDrop.addListener('place_changed', () => {
                    const place = autocompleteDrop.getPlace();
                    if (place.geometry) {
                    setDropLatLng({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });
                    setDropLocation(place.formatted_address || '');
                    }
                });
            }
        };

        loadAutocomplete();
    }, [isLoaded]);

    const [directions, setDirections] = useState(null);
    const [rideDistance, setRideDistance] = useState(0);
    const [estimatedFare, setEstimatedFare] = useState(0);
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [data, setData] = useState([]);  // Holds the cumulative data
    const [loading, setLoading] = useState(false);  // Loading state
    const [error, setError] = useState(null);  // Error state
    const [hasMore, setHasMore] = useState(true);
    const [autoAssignParams, setAutoAssignParams] = useState({});
    const [autoAssigning, setAutoAssigning] = useState(false);

    const fetchDirections = () => {
        if (pickupLatLng && dropLatLng) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: pickupLatLng,
                destination: dropLatLng,
                travelMode: window.google.maps.TravelMode.DRIVING, // or WALKING, BICYCLING, etc.
            };
            directionsService.route(request, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    // console.log('ride distance = ', result.routes[0]);
                    setRideDistance(result.routes[0].legs[0].distance.value)
                    setPickupAddress(result.routes[0].legs[0].start_address);
                    setDropAddress(result.routes[0].legs[0].end_address);
                    setDirections(result);
                } else {
                    console.error("Directions request failed due to " + status);
                }
            });
        }
    };

    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '500px',
      };
    const center = {
        lat: 28.644800, lng: 77.216721
    };
    // const onLoad = React.useCallback(function callback(map) {
    //     if (driversData.length > 0){
    //         console.log('markersDadis', driversData)
    //         const bounds = new window.google.maps.LatLngBounds()
    //         driversData.forEach(marker => {
    //             bounds.extend(new window.google.maps.LatLng(marker.lat, marker.long));
    //         });
    //         map.fitBounds(bounds)
    //     }
    //     setMap(map)
    // }, [driversData, isNearbyDrivers, vehicleType, phone]);

    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    useEffect(() => {
        // Ensure the map is loaded before trying to fit bounds
        if (!map) {
            console.warn('Map is not loaded yet');
            return;
        }
    
        // Ensure driversData contains valid data
        if (driversData.length > 0) {
    
            try {
                const bounds = new window.google.maps.LatLngBounds();
    
                driversData.forEach((marker) => {
                    if (marker.current_latitude && marker.current_longitude) {
                        bounds.extend(new window.google.maps.LatLng(marker.current_latitude, marker.current_longitude));
                        if(pickupLatLng){
                            bounds.extend(new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng));
                        }
                        if(dropLatLng){
                            bounds.extend(new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng));
                        }
                    } else {
                        console.warn('Invalid marker data:', marker);
                    }
                });
    
                // Apply bounds only if valid
                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error fitting map bounds:', error);
            }
        }
    }, [map, driversData, userByPhone]);
    
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    useEffect(() => {
        if (pickupLatLng && dropLatLng) {
            fetchDirections(); // Fetch directions whenever the locations are set
        }
    }, [pickupLatLng, dropLatLng]);
    

    useEffect(() => {
        const fetchCityDrivers = async () => {
            try{
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();
                // const url = `${serverUrl}/driver/fetch_city_driver`;
                const url = serverUrl + "/driver/city_online_driver"
                const obj={
                    token: token, 
                    timestamp: timestamp,
                    city_id: cityFilter
                }
                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    console.log('toke====.....==== ', token);
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);
                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }

                if(response.flag === 200){
                    const cityDriversData = response.data;
                    setDriversData(cityDriversData);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            }
            catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchCityDrivers();
    }, [cityFilter])

    const findNearbyDrivers = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng)
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                console.log('toke====.....==== ', token);
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                for(var i=0;i<vehicleDetails.length;i++){
                    for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                        driversData.push(vehicleDetails[i].active_driver[j]);
                    }
                }
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if(dropLatLng)
        findNearbyDrivers();
    },[dropLatLng]);

    const searchDriverByPhone = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/customer/user_by_phone_no"
            const obj={
                token: token, 
                timestamp: timestamp,
                phone_number: phone
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                console.log('toke====.....==== ', token);
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const userbyPhone = response.data.user_details;
                setUserByPhone(userbyPhone);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const searchByPhone = () =>{
        // console.log('phone = ', phone);
        searchDriverByPhone();
    }

    const fetchDataByVehicleType = async() => {
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng)
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                console.log('toke====.....==== ', token);
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                for(var i=0;i<vehicleDetails.length;i++){
                    if(vehicleDetails[i].vehicle_id == vehicleType){
                        for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                            driversData.push(vehicleDetails[i].active_driver[j]);
                        }
                        setEstimatedFare(vehicleDetails[i].estimated_fare);
                    }
                }
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(()=>{
        if(vehicleType!=''){
            fetchDataByVehicleType();
        }
        
    }, [vehicleType]);

    const autoAssignRide = async() =>{
        const token = localStorage.getItem('token');
        const timestamp = new Date().getTime();
        const url = autosUrl + "/customer/request_ride"
        const params={
            user_id: userByPhone.user_id,
            timestamp: timestamp,
            pickup_latitude: pickupLatLng ? pickupLatLng.lat : '',
            pickup_longitude: pickupLatLng ? pickupLatLng.lng : '',
            drop_latitude: dropLatLng ? dropLatLng.lat : '',
            drop_longitude: dropLatLng ? dropLatLng.lng : '',
            ride_distance: rideDistance,
            vehicle_id: vehicleType,
            pickup_address: pickupAddress,
            drop_address: dropAddress,
            estimated_fare: estimatedFare
        }
        // console.log(' === params === ', params);
        setAutoAssignParams(params);
    }

    useEffect(() => {
        autoAssignRide();
    }, [hasMore, loading, vehicleType])

    const setAutoAsigningTrue = () =>{
        autoAssignRide();
        setAutoAssigning(true);
        setFullScreenLoader(true);
        console.log('setting autoAssigning');
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Manual Dispatcher</Typography>
            <Grid2 container item spacing={2} sx={{display:'flex'}}>
                <Grid2 item size={4.5}>
                    <Grid2 item sx={{display:'flex', marginTop:'2%'}}>
                        <Grid2 sx={{marginRight:'4%'}}>
                            <Select
                                value={cityFilter}
                                onChange={(e) => handleFilterChange('city', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '200px',
                                    height: '46px',
                                    borderRadius: '8px',
                                    backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_id} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>
                        {/* <Grid2>
                            <input type="number" placeholder="Search Driver" className='filterBtn' style={{width:'200px'}}/>
                        </Grid2> */}
                    </Grid2>


                    <Grid2 container item sx={{marginTop:'2%', maxHeight:'700px', overflowY:'auto'}}>
                        {driversData &&  driversData.length>0 ? 
                            (driversData.map((marker) => (

                                <Grid2 item className="mainBox" sx={{marginTop:'4%'}}>
                                    <Grid2 item container>
                                        <Grid2 item size={2}>
                                            {marker.driver_image!="" && (
                                                <Avatar sx={{borderColor:'#0065FF', border:1}} alt={marker.driver_image} src={marker.driver_image} ></Avatar>
                                            )}
                                            {marker.driver_image==="" && (
                                                <Avatar sx={{borderColor:'#0065FF', border:1}} alt={altAvatar} src={altAvatar} ></Avatar>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={7}>
                                            <Typography sx={{fontSize:'16px', color:'#83888E'}}>{marker.driver_name}</Typography>
                                            <Typography>ID: {marker.driver_id}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: marker.driver_status==0 ? '#F9E9E9' : '#E7F8F2',
                                                    color: marker.driver_status==0 ? '#D14545' : '#0DBA78',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '60px',
                                                    border:'none',
                                                    boxShadow: 'none',
                                                    fontFamily: 'Poppins',
                                                    marginRight:'16px'
                                                }}
                                            >
                                                <FiberManualRecordIcon style={{ fontSize: '16px' }}/> {marker.driver_status == 0 ? 'Inactive' : 'Active'}
                                            </Button>
                                        </Grid2>
                                    </Grid2>

                                    <Box
                                        sx={{
                                            height: "1px", // Height of the line
                                            width: "100%", // Full width
                                            margin: "20px 0", // Spacing
                                            background: "linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))", // Fading effect
                                            borderTop: "2px dashed transparent", // Maintain dashed style
                                            maskImage: "linear-gradient(to right, black, transparent)", // Fade the dash pattern
                                            WebkitMaskImage: "linear-gradient(to right, black, transparent)", // For WebKit browsers
                                        }}
                                        />

                                    <Grid2 item container sx={{marginTop:'2%'}}>
                                        <Grid2 item size={1.5} sx={{marginTop:'1%'}}>
                                            {marker.vehicle_type==1 && (
                                                <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                            )}
                                            {marker.vehicle_type==2 && (
                                                <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                            )}
                                            {marker.vehicle_type==3 && (
                                                <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={8}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>Economy</Typography>
                                            <Typography sx={{color:'#4E545D', fontSize:'14px'}}>{marker.vehicle_no}</Typography>
                                        </Grid2>
                                        {/* <Grid2 item size={2}>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: '#F9F9F9',
                                                    color: '#83888E',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '60px',
                                                    border:'none',
                                                    boxShadow: 'none',
                                                    fontFamily: 'Poppins',
                                                    marginRight:'16px'
                                                }}
                                            >
                                                10km
                                            </Button>
                                        </Grid2> */}
                                    </Grid2>

                            
                                    {vehicleType && (
                                        <Grid2 item container sx={{marginTop:'2%'}}>
                                            <Grid2 item size={6}>
                                                <Button variant="contained" sx={{backgroundColor:'#F9F9F9', border:'1px solid #D1D5DB', width:'98%', boxShadow:'none'}}>
                                                    <Typography sx={{color:'#83888E', textTransform:'none'}}>Assign</Typography>
                                                </Button>
                                            </Grid2>
                                            <Grid2 item size={6}>
                                                <Button variant="contained" sx={{backgroundColor:'#F3F8FF', border:'1px solid #0065FF', width:'98%', boxShadow:'none'}}>
                                                    <Typography sx={{color:'#0065FF', textTransform:'none'}}>Force Assign</Typography>
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    )}
                                    
                                </Grid2>
                            )))
                            : (<div style={styles.errorBox}>
                                <p>No driver is online at this time.</p>
                            </div>)
                        }
                    </Grid2>

                </Grid2>
                {/* <Grid2 item size={0.2}></Grid2> */}
                <Grid2 item size={7.5} className="mainBox" sx={{marginTop:'1%'}}>
                    <Typography sx={{color: '#83888E', fontSize:'18px'}}>Enter Locations</Typography>
                    <Grid2 item sx={{display:'flex', marginTop:'1%'}}>
                        <Grid2 item>
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder=" Enter Pickup Location"
                                className="filterBtn"
                                style={{
                                    width: '280px', 
                                    paddingLeft: '32px', // Add space for the icon on the left 
                                    backgroundImage: `url(${pickupMarker})`, // Replace with your icon URL
                                    backgroundPosition: '8px center', // Position the icon on the left side
                                    backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                    backgroundSize: '20px 20px',
                                }}
                                value={pickupLocation}
                                onChange={(e) => setPickupLocation(e.target.value)}  // Optional: Update the state as user types
                            />
                            {/* <input type="number" placeholder="Enter Pickup Location" className='filterBtn' style={{width:'280px'}}/> */}
                        </Grid2>
                        <Grid2 item>

                        </Grid2>
                        <Grid2 item sx={{marginLeft:'2%'}}>
                            <input
                                ref={inputDropRef}
                                type="text"
                                placeholder=" Enter drop Location"
                                className="filterBtn"
                                style={{
                                    width: '280px', 
                                    paddingLeft: '32px', // Add space for the icon on the left 
                                    backgroundImage: `url(${dropMarker})`, // Replace with your icon URL
                                    backgroundPosition: '8px center', // Position the icon on the left side
                                    backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                    backgroundSize: '20px 20px',
                                }}
                                value={dropLocation}
                                onChange={(e) => setDropLocation(e.target.value)}  // Optional: Update the state as user types
                            />
                            {/* <input type="number" placeholder="Enter Drop Location" className='filterBtn' style={{width:'280px'}}/> */}
                        </Grid2>
                    </Grid2>

                    <Grid2 item sx={{marginTop:'2%'}}>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                
                                {pickupLatLng && (
                                    <Marker position={pickupLatLng} title="Pickup Location" 
                                        icon={{
                                            url: pickupMarker,
                                            scaledSize: new window.google.maps.Size(20, 20)
                                        }}
                                    />
                                )}
                                
                                {dropLatLng && (
                                    <Marker position={dropLatLng} title="Drop Location" 
                                        icon={{
                                            url: dropMarker,
                                            scaledSize: new window.google.maps.Size(20, 20) 
                                        }} 
                                    />
                                )}
                                
                                {directions && (
                                    <DirectionsRenderer
                                        directions={directions}
                                    />
                                )}
                                
                                {/* {driversData.length > 0 && driversData.map((marker) => (
                                    <Marker
                                        key={marker.driver_id}
                                        position={{ lat: marker.current_latitude, lng: marker.current_longitude }}
                                        title={marker.driver_name} // Tooltip text when hovering over the marker
                                        icon={{
                                            url: mapPin,
                                            scaledSize: new window.google.maps.Size(20, 20) 
                                        }}
                                    />
                                ))} */}
                                {!isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                    // console.log('drivrfdw', marker.current_latitude, marker.current_longitude) // Skip invalid markers
                                    return (
                                        <Marker
                                            key={marker.driver_id}
                                            position={{ lat: Number(marker.current_latitude), lng: Number(marker.current_longitude) }}
                                            title={marker.driver_name} // Tooltip text when hovering over the marker
                                            icon={{
                                                url: mapPin,
                                                scaledSize: new window.google.maps.Size(24, 24)
                                            }}
                                        />
                                    );
                                })}

                                {isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                    
                                    const vehicleIcon = marker.vehicle_type==1 ? CarMarker : marker.vehicle_type==2 ? BikeMarker : AutoMarker;
                                    return (
                                        <Marker
                                            key={marker.driver_id}
                                            position={{ lat: Number(marker.current_latitude), lng: Number(marker.current_longitude) }}
                                            title={marker.driver_name} // Tooltip text when hovering over the marker
                                            icon={{
                                                url: vehicleIcon,
                                                scaledSize: new window.google.maps.Size(30, 30)
                                            }}
                                        />
                                    );
                                })}

                            </GoogleMap>
                            
                        ): (<></>)}

                    </Grid2>

                    <Grid2 item sx={{marginTop:'2%'}}>
                        <Typography sx={{color:'#83888E'}}>Enter User Details</Typography>
                    </Grid2>

                    <Grid2 item size={12} sx={{marginTop:'2%', display:'flex'}}>
                        <Grid2 item size={9}>
                            
                            <PhoneInput
                                defaultCountry="IN"
                                style={{
                                    // width: '380px',  // Set width
                                    height: '44px',  // Set height
                                    fontSize: '16px',
                                    alignItems:'normal'
                                }}
                                placeholder=" Enter phone number"
                                value={phone}
                                onChange={setPhone}
                            />
                        </Grid2>
                        <Grid2 item size={3.5} sx={{marginLeft:'3%'}}>
                            <Button sx={{textTransform:'none', backgroundColor:'#FAFAFA', borderRadius:'2px',
                            color:'#353935', width: '170px', height: '44px'}} onClick={searchByPhone}>
                                Fetch Details
                            </Button>
                        </Grid2>
                    </Grid2>

                    {userByPhone && (
                        <Grid2 item container spacing={2} size={12} sx={{marginTop:'2%', display:'flex'}}>
                            <Grid2 item size={4} sx={{display: 'flex',alignItems: 'center', justifyContent:'center'}}>
                                <Typography sx={{fontWeight:'200', fontSize:'16px', color:'#4E545D', padding: '5px'}}>User Name :</Typography>
                                <Typography sx={{fontWeight:'', fontSize:'20px', color:'#4E545D'}}>{userByPhone.user_name}</Typography>
                            </Grid2>
                            <Grid2 item size={4}>
                                <Select
                                    value={vehicleType}
                                    onChange={(e) => setVehicleType(e.target.value)}
                                    displayEmpty
                                    style={{
                                        width: '200px',
                                        height: '46px',
                                        borderRadius: '8px',
                                        backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                                    }}
                                >
                                    <MenuItem value="">Select Vehicle</MenuItem>
                                    {vehicleDetails.map((vehicle) => (
                                        <MenuItem key={vehicle.vehicle} value={vehicle.vehicle_id}>
                                            {vehicle.vehicle_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                            
                            {vehicleType && (
                                <Grid2 item size={4}>
                                    <Button sx={{textTransform:'none', padding:'10px 32px', border:'1px solid #0065FF', backgroundColor:'#F3F8FF',
                                    color:'#0065FF'}} onClick={setAutoAsigningTrue}>
                                        Auto Assign Ride
                                    </Button>
                                    {autoAssigning && fullScreenLoader && (
                                        <Box
                                            sx={{
                                                position: "fixed",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark overlay
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                zIndex: 1300, // Ensure it's above other elements
                                            }}
                                        >
                                            {/* Centered Modal Box */}
                                            <Box
                                                sx={{
                                                    backgroundColor: "#FFFFFF", // Modal background color
                                                    borderRadius: "16px", // Rounded corners
                                                    width: "400px", // Fixed width
                                                    padding: "24px", // Padding for internal spacing
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", // Box shadow for elevation
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center", // Center content horizontally
                                                    textAlign: "center", // Center text
                                                }}
                                            >
                                                {/* Title */}
                                                <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
                                                    Auto Assigning
                                                </Typography>

                                                {/* Subtext */}
                                                <Typography sx={{ fontSize: "14px", color: "#6E6E6E", marginBottom: "24px" }}>
                                                    Please wait until the driver accepts the request.
                                                </Typography>

                                                {/* Lottie Animation */}
                                                <Box
                                                    sx={{
                                                        width: "350px", // Adjust size of the Lottie animation
                                                        height: "200px",
                                                        marginBottom: "24px", // Space between Lottie and cancel button
                                                    }}
                                                >
                                                    <Lottie animationData={loadingAnimation} loop={true} />
                                                </Box>

                                                {/* Cancel Button */}
                                                <Typography
                                                    onClick={() => setFullScreenLoader(false)}
                                                    sx={{
                                                        cursor: "pointer",
                                                        color: "#0065FF", // Blue text color
                                                        fontWeight: "500", // Slightly bold text
                                                        fontSize: "14px",
                                                        textDecoration: "none",
                                                        "&:hover": {
                                                            textDecoration: "underline", // Add underline on hover
                                                        },
                                                    }}
                                                >
                                                    Cancel
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                    {autoAssigning && fullScreenLoader && (
                                        <RideRequestComponent autoAssignParams={autoAssignParams} setFullScreenLoader={setFullScreenLoader} />
                                    )}

                                </Grid2>
                            )}
                            
                        </Grid2>
                    )} 
                    
                </Grid2>
            </Grid2>
                
        </div>
    )
}

export default Dispatcher;